// A guest (anonymous session with a library) who signs in to an EXISTING account gets a
// different user_id, so the rows written under the guest id would be orphaned. Stash them
// right before the session is replaced; carry them onto the new account on its first
// SIGNED_IN (useAuth). Existing rows on the account win (ignoreDuplicates).
const KEY = 'nextep_guest_carry'
const MAX_AGE = 24 * 60 * 60 * 1000

export async function stashGuestList(supabase, uid) {
  if (!supabase || !uid) return 0
  try {
    const { data } = await supabase.from('watchlist').select('*').eq('user_id', uid)
    // Drop the row id too: watchlist's primary key is `id`, so carrying it over would
    // collide with the guest row itself and ignoreDuplicates would skip every row.
    const rows = (Array.isArray(data) ? data : []).map(({ user_id, id, ...r }) => r)
    if (!rows.length) { localStorage.removeItem(KEY); return 0 }
    localStorage.setItem(KEY, JSON.stringify({ uid, ts: Date.now(), rows }))
    return rows.length
  } catch { return 0 }
}

export async function carryGuestList(supabase, uid, dispatch = null) {
  let stash
  try { stash = JSON.parse(localStorage.getItem(KEY) || 'null') } catch { stash = null }
  if (!stash || !supabase || !uid) return 0
  if (stash.uid === uid || !Array.isArray(stash.rows) || !stash.rows.length || Date.now() - (stash.ts || 0) > MAX_AGE) {
    try { localStorage.removeItem(KEY) } catch {}
    return 0
  }
  const { error } = await supabase.from('watchlist')
    .upsert(stash.rows.map(({ id, ...r }) => ({ ...r, user_id: uid })), { onConflict: 'user_id,show_id', ignoreDuplicates: true })
  if (error) return 0
  try { localStorage.removeItem(KEY) } catch {}
  const emit = dispatch || ((name) => { try { window.dispatchEvent(new Event(name)) } catch {} })
  emit('nextep:watchlist-refresh')
  return stash.rows.length
}
